import { supabase } from '../lib/supabase';

export interface ExistingMandate {
  id: string;
  property_number: string;
  seller: string | null;
  buyer: string | null;
  status: string;
  mandate_date: string | null;
  compromise_date: string | null;
}

/** Normalisation : les numéros saisis peuvent contenir des espaces ou une casse différente */
const normalize = (value: string) => value.trim().toLowerCase();

/**
 * Transactions existantes portant le même numéro de mandat.
 * `excludeId` écarte la transaction en cours de modification.
 */
export async function findTransactionsByMandateNumber(
  mandateNumber: string,
  excludeId?: string
): Promise<ExistingMandate[]> {
  const wanted = normalize(mandateNumber);
  if (!wanted) return [];

  // ilike large puis comparaison stricte : rattrape les numéros stockés avec des
  // espaces parasites sans remonter les numéros simplement voisins (1008 / 10081)
  const { data, error } = await supabase
    .from('transactions')
    .select('id, property_number, seller, buyer, status, mandate_date, compromise_date')
    .ilike('property_number', `%${wanted}%`);

  if (error) throw error;

  return (data || []).filter(
    t => normalize(t.property_number || '') === wanted && t.id !== excludeId
  );
}

const STATUS_LABELS: Record<string, string> = {
  potentiel: 'potentielle',
  compromis: 'sous compromis',
  acte: 'actée',
  encaisse: 'encaissée',
  cloture: 'clôturée',
  annule: 'annulée'
};

/** Libellé d'une transaction existante : « GUILLEMOT → JACQ (clôturée, mandat du 14/06/2026) » */
export function describeMandate(t: ExistingMandate): string {
  const parties = `${t.seller || '—'} → ${t.buyer || '—'}`;
  const status = STATUS_LABELS[t.status] || t.status;
  const date = t.mandate_date || t.compromise_date;
  const dateLabel = date ? `, ${new Date(date).toLocaleDateString('fr-FR')}` : '';
  return `${parties} (${status}${dateLabel})`;
}
